import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {Factor} from "../../model/factor";
import {Subscription} from "rxjs/Subscription";
import {ConditionFactorService} from "../../Services/condition-factor-service";
import {SliderService} from "../../Services/slider-service";
import {QueryService} from "../../Services/query-service";
import {QueryNode} from "@ispm-client/modules/query-builder/models/query-builder-config";

@Component({
  selector: 'gen-factor-editor',
  templateUrl: './factor-editor.component.html',
  styleUrls: ['./factor-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class FactorEditorComponent implements OnInit, OnDestroy {
  @Input() factor: Factor;
  @Output() cloneMe = new EventEmitter<Factor>();
  @Output() deleteMe = new EventEmitter<Factor>();

  editing: boolean = false;
  private conditionFactorSubscription: Subscription;

  constructor(private changeDetector: ChangeDetectorRef, private queryService: QueryService,
              private conditionFactorService: ConditionFactorService, private sliderService: SliderService) {
  }

  ngOnInit() {
    this.conditionFactorSubscription = this.conditionFactorService.item$
      .subscribe((update: boolean) => {
        if (update) {
          this.changeDetector.markForCheck();
        }
        this.editing = false;
      });
  }

  ngOnDestroy() {
    this.conditionFactorSubscription.unsubscribe();
  }

  editQuery() {
    this.editing = true;
    this.sliderService.editFactor(this.factor);
  }

  onCloneMe(): void {
    this.cloneMe.emit(this.factor);
  }

  onDeleteMe(): void {
    this.deleteMe.emit(this.factor);
  }

  public get representation() {
    let queryNode: QueryNode = this.factor.queryNode;
    if (queryNode) {
      let rule = queryNode.rules[0];
      let ruleType = rule.type.toUpperCase();
      if (ruleType == "PARAMETER" && rule.parameter) {
        return this.queryService.getRepresentation(queryNode);
      }
      else if (ruleType == "PARAMETER_SET" && rule.rules[0].parameter) {
        return this.queryService.getRepresentation(queryNode);
      }
    }
  }
}
